"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerComponents = void 0;
function registerComponents(components, context, _a) {
    var registerComponent = _a.registerComponent, registerLibrary = _a.registerLibrary;
    var library = context.library, manifest = context.manifest, assets = context.assets;
    if (Object.keys(components).length) {
        if (registerComponent) {
            Object.keys(components).forEach(function (componentName) {
                var loader = components[componentName];
                registerComponent(componentName, loader, library.artifactId);
            });
        }
        if (registerLibrary) {
            registerLibrary(library.artifactId, components, __spreadArrays(assets, manifest.assets));
        }
    }
}
exports.registerComponents = registerComponents;
//# sourceMappingURL=registerComponents.js.map